import { render, staticRenderFns } from "./DocumentationLayout.vue?vue&type=template&id=310abea9&"
import script from "./DocumentationLayout.vue?vue&type=script&lang=js&"
export * from "./DocumentationLayout.vue?vue&type=script&lang=js&"
import style0 from "./styles.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports